import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import FloatingBubbles from "@/components/FloatingBubbles";
import GlobalBackground from "@/components/GlobalBackground";
import PawCursor from "@/components/PawCursor";

function App() {
  return (
    <div className="App relative min-h-screen overflow-hidden">
      <GlobalBackground />
      <FloatingBubbles />
      <PawCursor />

      <BrowserRouter>
        <div className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </div>
      </BrowserRouter>

      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
